import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkConfig } from "@src/store/createAsyncThunk";
import { updateAnalyticsProducts } from "@src/store/slices/analyticsProducts/thunks/updateAnalyticsProducts";
import {
  closeProductPicker,
  getProductPickerSelectedIds,
} from "@src/store/slices/productPicker";

export const saveAnalyticsProductPicker = createAsyncThunk<
  void,
  void,
  ThunkConfig
>("productPicker/saveAnalyticsProductPicker", (_, { getState, dispatch }) => {
  const productIds = getProductPickerSelectedIds(getState());

  void dispatch(updateAnalyticsProducts(productIds));

  dispatch(closeProductPicker());
});
